// extracted by mini-css-extract-plugin
module.exports = {"odonto_implantes__redText":"OdontoImplantes_odonto_implantes__redText__2UOzE","odonto_implantes__image":"OdontoImplantes_odonto_implantes__image__1FFzr"};